import constant from '../../constant';
import request from '../../../utils/request';
import { GET_SHARE_PAGE_USERINFO } from '../../../urls'
import { showTip } from '../../../utils'

const getUserInfo = (params = {}) => {

  return async (dispatch) => {
    try {
      let sUserId = params.sUserId
      const shSid = params.shSid
      let sidParams = shSid && shSid.split('__')
      sUserId = sUserId || (sidParams.length>1 && sidParams[1])
      if (sUserId) {
        const { sGuid: guid, actType, ch } = params

        const res = await request.get(GET_SHARE_PAGE_USERINFO, {
          sUserId,
          guid,
          eAccountType: actType
        })

        if (res.code === 0) {
          const data = res.data || {}

          if (Number(actType) === -1) return

          const userInfo = {}

          if (data && data.userInfo) {
            Object.assign(userInfo, {
              faceIcon: data.userInfo.sFaceIcon,
              nickName: data.userInfo.sNickname
            })
          }
  
          Object.assign(userInfo, {
            usedDay: data.usedDay,
            actType,
            sUserId,
            guid,
            ch
          })
          dispatch(getUserInfoSuccess(userInfo))
        }
      } else {
        console.log('missed shSid')
      }

    } catch (error) {
      console.log('getUserInfo error', error)
      showTip(error.msg || '服务异常，请稍后再试')
    }
  }
}


const getUserInfoSuccess = (userInfo) => {
  return {
    type: constant.USERINFO.GET,
    userInfo
  }
}

export default {
  getUserInfoSuccess,
  getUserInfo
}